export enum AttachmentsEvents {
  FilesAttached = 'attachment.FilesAttached'
}
